<template>
  <v-container fluid>
    <!-- Sezione Password -->
    <v-form ref="formPwd" lazy-validation>
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-text-field hide-details label="Nuova Password" v-model="cliente.passwordHash" required
            :rules="validazionePassword" :type="mostraPassword1 ? 'text' : 'password'"
            :append-icon="mostraPassword1 ? 'visibility_off' : 'visibility'"
            @click:append="mostraPassword1 = !mostraPassword1" />
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field hide-details label="Ripeti Password" :value="psw" @input="$emit('update:psw', $event)"
            required :rules="validazioneConfermaPassword" :type="mostraPassword2 ? 'text' : 'password'"
            :append-icon="mostraPassword2 ? 'visibility_off' : 'visibility'"
            @click:append="mostraPassword2 = !mostraPassword2" />
        </v-col>
        <v-col cols="12" md="4">
          <v-btn block @click="$emit('genera-link')">
            <v-icon left small>link</v-icon> Genera link reset password
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <!-- Stato Cliente -->
    <v-row align="center" class="mt-3">
      <v-col cols="auto">
        <span class="text-subtitle-1">Stato:</span>
      </v-col>
      <v-col cols="auto">
        <v-switch v-model="cliente.enabled" color="primary" hide-details class="ma-0" />
      </v-col>
    </v-row>

    <!-- Registri di sintesi -->
    <v-row class="mt-1">
      <v-col cols="12">
        <v-checkbox label="Abilita registro di sintesi FSC" v-model="cliente.abilitaRegistro" hide-details />
        <v-checkbox label="Abilita registro di sintesi PEFC" v-model="cliente.abilitaRegistroPEFC" hide-details />
        <v-checkbox label="Abilita registro sintesi personalizzato" v-model="cliente.abilitaRegistroPers" hide-details />
        <v-select v-if="cliente.abilitaRegistroPers" v-model="cliente.varianteRegistroPers"
          :items="variantiRegistroPers" item-text="text" item-value="value" label="Variante registro sintesi pers."
          :rules="[(v) => !!v || 'Campo obbligatorio']" class="mt-2" style="max-width: 360px" dense outlined />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "AltriDati",

  props: {
    cliente: {
      type: Object,
      required: true,
    },
    modifica: {
      type: Boolean,
      default: false,
    },
    psw: {
      type: String,
      default: "",
    },
  },

  data: () => ({
    mostraPassword1: false,
    mostraPassword2: false,
    variantiRegistroPers: [
      { text: "Cartone (fogli / scatole)", value: "CARTONE" },
      { text: "Legno (mc / ml)", value: "LEGNO" },
    ],
  }),

  computed: {
    validazionePassword() {
      return [(v) => (v && v.length > 0) || "Campo obbligatorio"];
    },

    validazioneConfermaPassword() {
      return [(v) => (v && v.length > 0) || "Campo obbligatorio"];
    },
  },
};
</script>
